import { Routes } from 'react-router-dom';
import { Page404 } from 'framework/statusPages';
import useAuthenticationService from 'infrastructure/security/authentication/authenticationService';
import { ProtectedRouter } from 'infrastructure/routing';
import { Route, Router } from 'framework/routing';
import SyberryTodayPage from './List/SyberryTodayPage';

export const SYBERRY_TODAY_PATH = '/syberry-today';

const SyberryTodayRouter: Router = () => {
  const { isAuthenticated } = useAuthenticationService();

  return (
    <ProtectedRouter basePath={SYBERRY_TODAY_PATH}>
      <Routes>
        <Route index element={<SyberryTodayPage />} />
        <Route path="*" element={<Page404 isAuthenticated={isAuthenticated} />} />
      </Routes>
    </ProtectedRouter>
  );
};

SyberryTodayRouter.getRouterPath = () => `${SYBERRY_TODAY_PATH}/*`;

export default SyberryTodayRouter;
